// src/components/BusinessCardFlow/components/ContactReview.js
import React from 'react';

export default function ContactReview({ data, update }) {
  const containerStyle = {
    backgroundColor: '#444',
    padding: '1rem',
    borderRadius: '0.5rem',
    width: '100%',
    maxWidth: '400px',
    marginBottom: '1rem'
  };
  const labelStyle = {
    display: 'block',
    fontSize: '0.85rem',
    marginBottom: '0.2rem',
    color: '#ccc'
  };
  const inputStyle = {
    width: '100%',
    padding: '0.5rem',
    marginBottom: '0.8rem',
    borderRadius: '0.25rem',
    border: 'none',
    backgroundColor: '#666',
    color: '#fff'
  };

  const handleChange = (field, value) => {
    update({ ...data, [field]: value });
  };

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>Name</label>
      <input
        style={inputStyle}
        value={data.name || ''}
        onChange={(e) => handleChange('name', e.target.value)}
      />

      <label style={labelStyle}>Email</label>
      <input
        style={inputStyle}
        value={data.email || ''}
        onChange={(e) => handleChange('email', e.target.value)}
      />

      <label style={labelStyle}>Phone</label>
      <input
        style={inputStyle}
        value={data.phone || ''}
        onChange={(e) => handleChange('phone', e.target.value)}
      />

      <label style={labelStyle}>Organization</label>
      <input
        style={inputStyle}
        value={data.organization || ''}
        onChange={(e) => handleChange('organization', e.target.value)}
      />

      <label style={labelStyle}>Position</label>
      <input
        style={inputStyle}
        value={data.position || ''}
        onChange={(e) => handleChange('position', e.target.value)}
      />

      <label style={labelStyle}>Industry</label>
      <select
        style={inputStyle}
        value={data.industry || ''}
        onChange={(e) => handleChange('industry', e.target.value)}
      >
        {[
          'Construction',
          'Manufacturing',
          'Healthcare',
          'Finance',
          'Technology',
          'Education',
          'Government',
          'Other'
        ].map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>

      <label style={labelStyle}>Comments</label>
      <textarea
        style={inputStyle}
        rows={2}
        value={data.comment || ''}
        onChange={(e) => handleChange('comment', e.target.value)}
      />

      <label style={labelStyle}>AI Interests</label>
      <input
        style={inputStyle}
        value={(data.ai_interests || []).join(', ')}
        onChange={(e) => {
          const arr = e.target.value.split(',').map((s) => s.trim());
          handleChange('ai_interests', arr);
        }}
      />
    </div>
  );
}
